/**
 * Decodes a Base64 string into a Uint8Array.
 *
 * @param {string} buffer - The Base64 encoded string.
 * @returns {Uint8Array|null} - The decoded buffer or null if decoding fails.
 */
export const decodeBuffer = (buffer, encoded = false) => {
    try {
        if(encoded){
            return new Uint8Array(new TextEncoder().encode(atob(buffer)));
        }
        return new Uint8Array(buffer);

    } catch (error) {
        console.error("Failed to decode buffer:", error.message);
        return null;
    }
}

/**
 * Processes print details from the print request.
 *
 * @param {Array} req - Array of print requests, each containing buffer and printer information.
 * @returns {Array} - Array of processed print details.
 */
export const processPrintDetails = (req) => {
    return req.flatMap((r) => {
        const decoded = decodeBuffer(r.buffer, r.encoded);

        // Skip invalid buffers
        if (!decoded) return [];

        // Create print details for each printer in the request
        return r.printers.map((p) => ({
            ...p,
            command: decoded,
        }));
    });
}

// PRINTER ERROR CODES
export const ERROR_CODES = {
    CONNECTION_ERROR: {
        code: 500,
        name: "CONNECTION_ERROR",
        message: "Failed to connect to the printer.",
    },
    INVALID_INPUT: {
        code: 400,
        name: "INVALID_INPUT",
        message: "Invalid input provided.",
    },
    TIMEOUT: {
        code: 408,
        name: "TIMEOUT",
        message: "The operation timed out.",
    },
    UNKNOWN: {
        code: 500,
        name: "UNKNOWN",
        message: "An unknown error occurred.",
    },
    NOT_SUPPORTED: {
        code: 501,
        name: "NOT IMPLEMENTED",
        message: "Action not supported",
    }
};

// Utility function to validate IP address
export const isValidIPAddress = (ip) => {
    const regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
    return regex.test(ip);
};

// Utility function to validate command
export const isValidCmd = (command) => {
    return (command instanceof Uint8Array)
}

// PRINTER TYPES
export const PRINTER_TYPES = {
    NETWORK: {
        name: "Network Printer",
        value: "ip",
        comment: "Select a printer connected via network.",
    },
    BLUETOOTH: {
        name: "Bluetooth Printer",
        value: "bluetooth",
        comment: "Select a printer connected via Bluetooth.",
    },
    USB: {
        name: "USB Printer",
        value: "usb",
        comment: "Select a printer connected via USB.",
    },
    NO_PRINT: {
        name: "— Do Not Print —",
        value: "0",
        comment: "Choose this option if you do not want to print — no receipts will be generated.",
    }
};

